import {
  DisplaySettings,
  displaySettingsAction,
  PageName,
  replaceAllAction,
} from "../reducers/displaySettingsReducer";
import {
  FilterState,
  FiltersAction,
  filtersInitialState,
  replaceFiltersAction,
} from "../reducers/filtersReducer";

export interface LocalStorageSettings {
  filters: FilterState;
  displaySettings: DisplaySettings;
}

export const readLocalStorage = (
  displaySettingsDispatch: (action: replaceAllAction) => void,
  filtersDispatch: (action: replaceFiltersAction) => void
): void => {
  const local: string | null = localStorage.getItem("caseState");
  if (local) {
    const data: unknown = JSON.parse(local);
    const settings = data as LocalStorageSettings;
    filtersDispatch({
      type: FiltersAction.REPLACE,
      newFilters:{ ...filtersInitialState, ...settings.filters },
    });
    displaySettingsDispatch({
      type: displaySettingsAction.REPLACE_ALL,
      newSettings: settings.displaySettings,
    });
  }
};

export const resetLocalStorage = (): void => {
  const local: string | null = localStorage.getItem("caseState");
  if (local) {
    const data: unknown = JSON.parse(local);
    const settings = data as LocalStorageSettings;
    settings.displaySettings.pageName = PageName.ALL_CASES;
    settings.displaySettings.pagination.pageIndex = 0;
    delete settings.displaySettings.sort
    localStorage.setItem("caseState", JSON.stringify(settings));
  }
};

export const writeLocalStorage = (
  displaySettings: DisplaySettings,
  filters: FilterState,
): void => {
  const settings: LocalStorageSettings = {
    filters,
    displaySettings: { ...displaySettings },
  };
  localStorage.setItem("caseState", JSON.stringify(settings));
}